var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dowPdf",on:{"click":_vm.rightShare}},[_vm._v("下载详情")])
}
var staticRenderFns = []

export { render, staticRenderFns }